import { useEffect } from 'react';
import { useParams } from 'react-router';
import { useCaseCloningLock } from '@/hooks';
import {
  setSharedDataActiveTimelineChronologyType,
  setTimelineChronologyActiveEntryIndex,
  setTimelineChronologySelectedEntryIds,
  TimelineChronologyType,
  useAppDispatch,
} from '@/store';
import { TimelineChronologyPage } from './TimelineChronologyPage';

export const ChronologyPageContainer = () => {
  const dispatch = useAppDispatch();
  const { caseId } = useParams();

  useCaseCloningLock(caseId);

  useEffect(() => {
    dispatch(setSharedDataActiveTimelineChronologyType(TimelineChronologyType.CHRONOLOGY));

    return () => {
      dispatch(setSharedDataActiveTimelineChronologyType(null));
      dispatch(
        setTimelineChronologyActiveEntryIndex({
          key: TimelineChronologyType.CHRONOLOGY,
          data: null,
        }),
      );
      dispatch(
        setTimelineChronologySelectedEntryIds({
          key: TimelineChronologyType.CHRONOLOGY,
          data: [],
        }),
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <TimelineChronologyPage />;
};
